<h2 mat-dialog-title>Upload mesh options</h2>
<mat-dialog-content>
    <form id="uploadMeshForm" class="upload-mesh-form" (ngSubmit)="confirmAction()">
        <mat-radio-group [(ngModel)]="$selectedScaleOption" name="selectedScaleOption">
            <div class="upload-mesh-form">
                <mat-radio-button value="inputScale">
                    <div [class.cm-disabled-item]="$selectedScaleOption() !== 'inputScale'">Model Scale</div>
                    <mat-form-field appearance="fill">
                        <mat-select [(ngModel)]="$inputScale" name="inputScale" [disabled]="$selectedScaleOption() !== 'inputScale'">
                            <mat-option value="cm">cm</mat-option>
                            <mat-option value="m">meters</mat-option>
                            <mat-option value="mm">mm</mat-option>
                            <mat-option value="inches">inches</mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-radio-button>
                <mat-radio-button value="customScale"
                    ><div [class.cm-disabled-item]="$selectedScaleOption() !== 'customScale'">Custom Scale Factor</div>
                    <mat-form-field appearance="fill">
                        <input matInput type="number" [(ngModel)]="$customScale" name="customScale" [disabled]="$selectedScaleOption() !== 'customScale'" />
                    </mat-form-field>
                </mat-radio-button>
            </div>
        </mat-radio-group>
        @if ($scaleFactor() !== undefined) {
            <mat-checkbox [(ngModel)]="$scaleUv0" name="scaleUv0">Scale World Space UVs</mat-checkbox>
        }
        <mat-checkbox [(ngModel)]="$center" name="center">Center Origin</mat-checkbox>
        <mat-checkbox [(ngModel)]="$consolidate" name="consolidate">Weld Vertices</mat-checkbox>
        <mat-checkbox [(ngModel)]="$convertToWorldSpaceUvs" name="convertToWorldSpaceUvs">Convert to World Space UVs</mat-checkbox>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="cm-dialog-actions">
    <button mat-button type="submit" form="uploadMeshForm" autofocus>Ok</button>
    <button mat-button (click)="cancelAction()" autofocus>Cancel</button>
</mat-dialog-actions>
